var round = Math.round;
/**
 * Compute costs information for buyer (either he create buy listing or aggress the sell listing)
 *
 * @param value the single ticket price provided by listing creator [in cents]
 * @param ticketType type of tickets to buy/sell - in case of null, delivery fee won't be included
 * @param quantity the number of tickets to transact
 * @param vatRate the VAT rate as a fraction value from 0..1
 * @param buyerCommissionPercent buyer commission value as a fraction 0..1
 * @param buyerCommissionFlat buyer flat commission (independent of the quantity and value) [in cents]
 * @param deliveryFees fees settings for delivery
 * @param international whether it is an international or domestic delivery
 * @returns summary of costs for the buyer
 */
var getBuyCosts = function (value, ticketType, quantity, vatRate, buyerCommissionPercent, buyerCommissionFlat, deliveryFees, international) {
    if (international === void 0) { international = false; }
    var ticketsCost = round(value * quantity);
    var transactionFeeGross = round(buyerCommissionFlat + quantity * value * buyerCommissionPercent);
    var transactionFeeNet = round(transactionFeeGross / (1.0 + vatRate));
    var transactionFeeVAT = round(transactionFeeGross - transactionFeeNet);
    var ticketFee = quantity === 0 ? 0 : round(transactionFeeGross / quantity);
    var deliveryCostGross = ticketType == null
        ? 0
        : ['eTicket', 'mobileTransfer', 'ticketmaster', 'qrCode'].includes(ticketType)
            ? round(deliveryFees.eTicket)
            : international
                ? round(deliveryFees.paperInternational)
                : round(deliveryFees.paperDomestic);
    var deliveryCostNet = round(deliveryCostGross / (1.0 + vatRate));
    var deliveryCostVAT = round(deliveryCostGross - deliveryCostNet);
    var total = round(ticketsCost + transactionFeeGross + deliveryCostGross);
    return {
        ticketsCost: ticketsCost,
        ticketFee: ticketFee,
        transactionFeeNet: transactionFeeNet,
        transactionFeeVAT: transactionFeeVAT,
        transactionFeeGross: transactionFeeGross,
        deliveryCostNet: deliveryCostNet,
        deliveryCostVAT: deliveryCostVAT,
        deliveryCostGross: deliveryCostGross,
        total: total,
    };
};
/**
 * Compute costs information for seller (either by creating the sell listing or aggress the buy listing)
 *
 * @param value the single ticket price provided by listing creator [in cents]
 * @param quantity the number of tickets to transact
 * @param vatRate the VAT rate as a fraction value from 0..1
 * @param sellerCommissionPercent seller commission value as a fraction 0..1
 * @param sellerCommissionFlat buyer flat commission (independent of the quantity and value) [in cents]
 * @returns summary of costs for the seller
 */
var getSellCosts = function (value, quantity, vatRate, sellerCommissionPercent, sellerCommissionFlat) {
    var ticketsCost = round(value * quantity);
    var transactionFeeGross = round(sellerCommissionFlat + quantity * value * sellerCommissionPercent);
    var transactionFeeNet = round(transactionFeeGross / (1.0 + vatRate));
    var transactionFeeVAT = round(transactionFeeGross - transactionFeeNet);
    var ticketFee = quantity === 0 ? 0 : round(transactionFeeGross / quantity);
    var deliveryCostNet = 0;
    var deliveryCostVAT = 0;
    var deliveryCostGross = 0;
    var total = round(ticketsCost - (transactionFeeGross + deliveryCostGross));
    return {
        ticketsCost: ticketsCost,
        ticketFee: ticketFee,
        transactionFeeNet: transactionFeeNet,
        transactionFeeVAT: transactionFeeVAT,
        transactionFeeGross: transactionFeeGross,
        deliveryCostNet: deliveryCostNet,
        deliveryCostVAT: deliveryCostVAT,
        deliveryCostGross: deliveryCostGross,
        total: total,
    };
};

export { getBuyCosts, getSellCosts };
//# sourceMappingURL=index.es.js.map
